interface KeepOriginalChipProps {
	initialScore: number;
	onKeep: () => void;
}

export const KeepOriginalChip: React.FC<KeepOriginalChipProps> = ({
	initialScore,
	onKeep,
}) => {
	return (
		<button
			type="button"
			onClick={onKeep}
			className="bg-blue-50 text-blue-700 border border-blue-200 rounded-full px-2.5 py-0.5 text-xs cursor-pointer hover:bg-blue-100 transition-colors"
			data-testid="keep-original-chip"
		>
			Keep {initialScore}
		</button>
	);
};
